import React from 'react';
import './BankTransaction.css';

export const BankTransaction = ({ transaction }) => {
  // Determine if the transaction is a deposit or withdrawal
  // Handle both string amounts and numeric amounts
  const amount = typeof transaction.amount === 'string' ? parseFloat(transaction.amount.replace(/[^\d.-]/g, '')) : transaction.amount;
  const isDeposit = amount > 0;

  return (
    <div className="bank-transaction">
      <div className="transaction-header">
        <h4>Transaction Record</h4>
        <div className="transaction-date">{transaction.timestamp || ''}</div>
      </div>
      <div className="transaction-body">
        <div className="transaction-detail">
          <span className="detail-label">Account:</span>
          <span className="detail-value">{transaction.accountHolder || transaction.account || ''}</span>
        </div>
        <div className="transaction-detail">
          <span className="detail-label">Transaction Type:</span>
          <span className="detail-value">{transaction.transactionType || transaction.type || ''}</span>
        </div>
        {transaction.locationMerchant && (
          <div className="transaction-detail">
            <span className="detail-label">Description:</span>
            <span className="detail-value">{transaction.locationMerchant}</span>
          </div>
        )}
        <div className="transaction-detail">
          <span className="detail-label">Amount:</span>
          <span className={`detail-value amount ${isDeposit ? 'deposit' : 'withdrawal'}`}>
            {typeof transaction.amount === 'string' ? transaction.amount : `${isDeposit ? '+' : '-'}$${Math.abs(amount).toFixed(2)}`}
          </span>
        </div>
        {transaction.balance !== undefined && (
          <div className="transaction-detail">
            <span className="detail-label">Balance After:</span>
            <span className="detail-value">${transaction.balance.toFixed(2)}</span>
          </div>
        )}
      </div>
    </div>
  );
}; 